import React from 'react';
import { Utils } from '../../../../../shared';
import PlanAlignmentCards from './PlanAlignmentCards';
import CampaignDetailInfoCards from './CampaignDetailInfoCards';

/**
 * CampaignOverviewSection Component (Skeleton)
 * 
 * This component will display:
 * 1. Campaign Header Card - with campaign name, date range, synthesis ID, client code, product code
 * 2. Taxonomy Compliance Card - circular progress showing 100% compliance
 * 3. Linked Creatives Count Card
 * 4. Plan Alignment Card - with order progress bar and channel breakdown chart
 * 
 * Props:
 * @param {Object} campaignData - Campaign details including name, dates, metrics
 * @param {String} campaignId - Campaign ID
 * 
 * TODO for teammate:
 * - Implement campaign header with all fields from screenshot
 * - Add circular progress for taxonomy compliance (100%)
 * - Create linked creatives counter (0)
 * - Build plan alignment section with:
 *   - Order progress bar (0% - $0.00 / $400,000.00)
 *   - Channel breakdown chart (Planned vs Ordered)
 *   - Include non-digital checkbox
 * - Add "Edit taxonomy" button functionality
 * - Implement chart visualization for channel breakdown
 */
const CampaignOverviewSection = ({ campaignData }) => {
    return (
        <div className="campaign-overview-section">
            <CampaignDetailInfoCards
                campaignDetails={{
                    campaignName: campaignData.campaign_display_name,
                    dateRange: `${Utils.convertDateToDisplayFormat(
                        campaignData.campaignstart
                    )} - ${Utils.convertDateToDisplayFormat(
                        campaignData.campaignend
                    )}`,
                    mediaPlanSource: campaignData.data_source,
                    syntheticId: campaignData.synthetic_id,
                    productCode: campaignData.productid,
                    clientCode: campaignData.client_code,
                    planVersion: `${campaignData.filerevision}(${Utils.convertToYYYYMMDD(campaignData.file_date)})`,
                    lastModified: Utils.convertToYYYYMMDD(
                        campaignData.updated_at,
                        true
                    ),
                }}
                taxonomyCompliance={{
                    campaignId: campaignData.id,
                    versionOneApi: 'V3',
                }}
            />
            <PlanAlignmentCards
                planningSummary={{
                    plannedAmount:
                        campaignData.campaign_total_budget_local ||
                        campaignData.campaign_total_budget ||
                        0,
                    digitalBudget: campaignData?.onlineArr?.reduce(
                        (sum, data) => sum + (data.budget || 0),
                        0
                    ),
                    orderedAmount: campaignData.channels
                        ? campaignData.channels
                            .filter(
                                (data) =>
                                    data.export_status &&
                                    data.export_status.toLowerCase() === "campaign sent"
                            )
                            .reduce(
                                (sum, data) =>
                                    sum +
                                    (data.channel_total_budget_local ||
                                        data.channel_total_budget ||
                                        0),
                                0
                            )
                        : 0,
                }}
                channelsData={campaignData.media_attributes.channels}
            />

        </div>
    );
};

export default CampaignOverviewSection;
